module.exports = __webpack_public_path__ + "media/images/icon_calendar_25_25-46eab384166ef4912cd9e3955d59176e.png";